<nav
  kb-page-anchor-menu
  [ariaLabel]="attributes.ariaLabel ?? 'Page sections'"
  [items]="attributes.items"
></nav>
